import { SetLoader } from '../../redux/actions/loader'
import { GET, POST, DELETE } from '../API'
import { store } from '../../redux/store'
const { dispatch } = store

export {
  GetUserDevices,
  GetCustomerDevicesList,
  GetAssetInfo,
  getAssetDevices,
  saveAsset,
  GetDeviceInfo,
  ConfigureDevice,
  SendCommandToDevice,
  GetPaginationDevicesList,
  SendCommandDevice,
  GetAllDeviceInfo,
  SubmitAllDeviceInfo,
  DeleteDevice,
  deleteDeviceRelations,
  SendCommandDeviceFromTroubleShoot,
  DEVICE_STATUS_ENUM,
}

const DEVICE_STATUS_ENUM = {
  INSTALLED: 'INSTALLED',
  CONFIGURED: 'CONFIGURED',
  CONNECTED: 'CONNECTED',
  OFFLINE: 'OFFLINE',
}
// spectro/assets/customer/aa@spectro.net?product=tank&status=CONFIGURED&page=0&size=5
const GetPaginationDevicesList = async (
  userEmail,
  productName,
  currentPage,
  size,
  status,
  name,
  id,
  customerId,
) => {
  const queryParams = {
    product: productName,
    page: currentPage,
    size,
    status,
    name,
    id,
    customerId,
  }

  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )

  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  return []
}

const GetDeviceInfo = async (deviceId) => {
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/tankdevices/getConfigAttributeForTheDevice/${deviceId}`,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  return []
}

const DeleteDevice = async (deviceId) => {
  const response = await DELETE(`/spectro/tankdevices/deleteDevice/${deviceId}`)
  if (response) {
    return response
  }
  return []
}

const deleteDeviceRelations = async (deviceId) => {
  const response = await DELETE(`/spectro/tankdevices/delete/${deviceId}`)
  return response
}

const GetAllDeviceInfo = async (deviceId) => {
  dispatch(SetLoader(true))
  const response = await GET(
    `/spectro/tankdevices/getDeviceAttributes/${deviceId}`,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }

  return []
}

const SubmitAllDeviceInfo = async (body) => {
  const queryParams = null
  dispatch(SetLoader(true))
  const response = await POST(
    `/spectro/tankdevices/setDeviceAttribute/${body.deviceId}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.status
  }
  return []
}

const SendCommandDevice = async (deviceId, commandValue) => {
  const queryParams = null
  const body = {
    deviceId,
    commandValue,
  }
  const response = await POST(
    `/spectro/tankdevices/command/send_to_gateway`,
    queryParams,
    body,
  )
  if (response.success) {
    return response.status
  }
  return []
}

const SendCommandDeviceFromTroubleShoot = async (
  deviceId,
  commandValue,
  height,
  action,
  id,
) => {
  const queryParams = { height, action, id }
  const body = {
    deviceId,
    commandValue,
  }
  const response = await POST(
    `/spectro/tankdevices/command/send_to_gateway`,
    queryParams,
    body,
  )
  if (response.success) {
    return response.status
  }
  return []
}

const ConfigureDevice = async (height) => {
  const queryParams = {
    height,
  }
  // const body = {
  //   message: 'device.id',
  // }
  const response = await GET(
    `/spectro/tankdevices/sms/setHeight`,
    queryParams,
    // body,
  )
  return response
}

const SendCommandToDevice = async (height) => {
  const queryParams = {
    height,
  }
  // const body = {
  //   message: 'device.id',
  // }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/tankdevices/sms/setHeight`,
    queryParams,
    // body,
  )
  dispatch(SetLoader(false))

  return response
}

// get user devices
const GetUserDevices = async (userEmail, productName, status) => {
  const queryParams = {
    product: productName,
    status,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const GetCustomerDevicesList = async (userEmail, productName, status) => {
  dispatch(SetLoader(true))
  const queryParams = {
    status,
    product: productName,
  }
  if (status) {
    queryParams.status = status
  }

  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

const getAssetDevices = async (userEmail, productName, connectedStatus) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
    status: connectedStatus,
  }
  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}
// /spectro/assets/test 2222/customer/aa@spectro.net?product=cold
const GetAssetInfo = async (assetName, userEmail, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const response = await GET(
    `/spectro/assets/${assetName}/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  throw new Error(response.msg)
}

// http://localhost:9999/spectro/assets/customer/aa@spectro.net?product=cold

const saveAsset = async (userEmail, productName, bodyData) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const body = {
    'alarms attributes': {
      'critical high humidity alarm': bodyData.criticalHighHumidityAlarm,
      'critical high temp alarm': bodyData.criticalHighTempAlarm,
      'critical low temp alarm': bodyData.criticalLowTempAlarm,
      'device inactive alarm': bodyData.deviceInactiveAlarm,
      'door idle time alarm': bodyData.doorIdleTimeAlarm,
      'door left open alarm': bodyData.doorLeftOpenAlarm,
      'door neglect open alarm': bodyData.doorNeglectOpenAlarm,
      'out of location alarm': bodyData.outOfLocationAlarm,
      'power off alarm': bodyData.powerOffAlarm,
      'service request alarm': bodyData.serviceRequest,
      'unauthorized movement alarm': bodyData.unauthorizedMovementAlarm,
      'warning high humidity alarm': bodyData.warningHighHumidityAlarm,
      'warning high temp alarm': bodyData.warningHighTempAlarm,
      'warning low light alarm': bodyData.warningLowLightAlarm,
      'warning low temp alarm': bodyData.warningLowTempAlarm,
    },
    'asset thresholds': {
      'Unauthorized movement': bodyData.unauthorizedMovementThreshold,
      'compressor temperature': bodyData.compressorTemperatureThreshold,
      'compressor vibration': bodyData.compressorVibrationThreshold,
      'critical high temperature': bodyData.criticalHighTemperatureThreshold,
      'critical humidity': bodyData.criticalHumidityThreshold,
      'critical low temperature': bodyData.criticalLowTemperatureThreshold,
      'door left open': bodyData.doorOpenCountTimeSampling,
      'door open neglect': bodyData.doorOpenNeglectThreshold,
      'hw compressor ac current': bodyData.compressorTimeSampling,
      'hw compressor temperature': bodyData.compressorTimeSampling,
      'hw compressor vibrations': bodyData.compressorTimeSampling,
      'hw door open count': bodyData.doorOpenCountTimeSampling,
      'hw fridge interior humidity': bodyData.tempHumLightTimeSampling,
      'hw fridge interior light level': bodyData.tempHumLightTimeSampling,
      'hw fridge interior temperature': bodyData.tempHumLightTimeSampling,
      'hw room temperature': bodyData.roomTemperatureTimeSampling,
      'low light': bodyData.lowLightThreshold,
      'out of location': bodyData.outOfLocationThreshold,
      power: bodyData.powerThreshold,
      'warning high temperature': bodyData.warningHighTemperatureThreshold,
      'warning humidity': bodyData.warningHumidityThreshold,
      'warning low temperature': bodyData.warningLowTemperatureThreshold,
    },
    devices: bodyData.devices,
    'general attributes': {
      name: bodyData.name,
      type: bodyData.assetType,
      description: bodyData.description,
      location: bodyData.GPS,
    },
    'indoor fridge attributes': {
      model: bodyData.model,
      serial: bodyData.assetSerial,
    },
    'moving fridge attributes': {
      model: bodyData.model,
      'reseller name': bodyData.resellerName,
      serial: bodyData.assetSerial,
    },
    'related assets': [bodyData.region, bodyData.facility, bodyData.country],
    'reports attributes': {
      'humidity incompliance report': bodyData.humidityIncomplianceReport,
      'incompliant facilities report': bodyData.criticalLowTempAlarm,
      'light incompliance report': bodyData.lightIncomplianceReport,
      'movement relocation report': bodyData.movementRelocationReport,
      'temp incompliance report': bodyData.tempIncomplianceReport,
    },
  }

  const response = await POST(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))
  return response
}
